import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { PathShape, PathHollow } from '../shape';
import { baseGeometryChannels, basePostInference, basePreInference } from './utils';
var shape = {
  path: PathShape,
  hollow: PathHollow
};
/**
 * Draw a path.
 */
export var Path = function Path(options) {
  return function (index, scale, value, coordinate) {
    // The points is meaning less for path mark,
    // because the position of path shapes specified
    // by the d option. So set [0, 0] for render pipeline.
    return [index, index.map(function () {
      return [[0, 0]];
    })];
  };
};
Path.props = {
  defaultShape: 'path',
  defaultLabelShape: 'label',
  shape: shape,
  composite: false,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'd',
    scale: 'identity'
  }]),
  preInference: _toConsumableArray(basePreInference()),
  postInference: _toConsumableArray(basePostInference())
};